"use client";

import { useState } from "react";
import { Checkbox } from "@nextui-org/react";
import Header from "@/components/client/Header";
import HandicapOddRate from "./HandicapOddRate";
import OverUnderOddRate from "./OverUnderOddRate";
import NoData from "@/components/client/NoData";

const OddRateStats = ({ home: homeData, away: awayData, oddStats }) => {
  const [isSameChecked, setIsSameChecked] = useState(false);
  const [isHTChecked, setIsHTChecked] = useState(false);

  const data = oddStats?.oddRate || {};
  const odds = isSameChecked ? data?.similarity : data?.normal;

  const homeOdds = isHTChecked ? odds?.homeHalf : odds?.home;
  const awayOdds = isHTChecked ? odds?.awayHalf : odds?.away;

  const homeArray = homeOdds
    .split(",")
    .map((item) => (item === "-" ? 0 : item))
    .filter((item) => item !== 0);
  const awayArray = awayOdds
    .split(",")
    .map((item) => (item === "-" ? 0 : item))
    .filter((item) => item !== 0);

  const renderOddStats = () => {
    if (homeArray.length === 0 || awayArray.length === 0) {
      return (
        <div className={"lg:px-[34px]"}>
          <NoData />
        </div>
      );
    }

    return (
      <div className={"lg:px-[34px]"}>
        <div className={"flex flex-row items-center justify-between mt-4 lg:[&>*]:flex-1 "}>
          <div className={"flex flex-row justify-between mb-4 max-lg:gap-2 "}>
            <div
              className={
                "flex flex-col lg:flex-row justify-start gap-1lg:gap-4 [&>*]:flex [&>*]:flex-row [&>*]:justify-start lg:[&>*]:justify-center [&>*]:items-end lg:[&>*]:items-center [&>*]:gap-2 "
              }
            >
              <div>
                <div className={"w-3.5 h-3.5 bg-button-blue-bet"}></div>
                <div className={""}>Chủ</div>
              </div>
              <div>
                <div className={"w-3.5 h-3.5 bg-golden-yellow"}></div>
                <div className={""}>Khách</div>
              </div>
            </div>
          </div>

          <div
              className={
                "flex flex-col @md:flex-row justify-end gap-1  @md:gap-4  [&>*]:flex [&>*]:flex-row-reverse [&>*]:@md:flex-row [&>*]:justify-center [&>*]:items-center [&>*]:gap-1 w-[140px] @md:w-full items-end"
              }
            >
              <Checkbox
                color={"default"}
                size={"sm"}
                className={"max-lg:!flex-row-reverse max-lg:!text-right"}
                isSelected={isHTChecked}
                onValueChange={() => setIsHTChecked(!isHTChecked)}
              >
                HT
              </Checkbox>

              <Checkbox
                color={"default"}
                size={"sm"}
                className={"max-lg:!flex-row-reverse max-lg:!text-right"}
                isSelected={isSameChecked}
                onValueChange={() => setIsSameChecked(!isSameChecked)}
              >
                Chủ khách tương đồng
              </Checkbox>
            </div>
        </div>

        <div className="flex gap-1 w-full divide-x overflow-auto p-2">
          <HandicapOddRate homeArray={homeArray} awayArray={awayArray} />
          <OverUnderOddRate homeArray={homeArray} awayArray={awayArray} />
        </div>
      </div>
    );
  };

  return (
    <div className={" px-0 lg:px-8 py-4"}>
      <Header home={homeData} away={awayData} title="Thống kê Tỷ lệ kèo" />
      {renderOddStats()}
    </div>
  );
};

export default OddRateStats;
